<template>
  <div>
    <a-form :layout="formLayout" :form="form">
      <a-form-item
        label="手机号"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
        disabled="false"
          v-decorator="[
            'phone',
            {
              initialValue: phone,
            }
          ]"
          placeholder="请输入手机号"
        />
      </a-form-item>

      <a-form-item
        label="密码"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
          v-decorator="[
            'password',
            {
              initialValue: password,
            }
          ]"
          placeholder="请输入密码"
        />
      </a-form-item>

      <a-form-item
        label="姓名"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-input
          v-decorator="[
            'name',
            {
              initialValue: name,
              rules: [{ required: true, min: 1,max:20, message: '姓名（1-20位）' }]
            }
          ]"
          placeholder="请输入姓名"
        />
      </a-form-item>

      <a-form-item
        label="性别"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-select
          v-decorator="[
            'sex',
            {
              initialValue: sex,
            }
          ]"
          style="width: 120px"
          @change="handleChange"
        >
          <a-select-option value="0">男</a-select-option>
          <a-select-option value="1">女</a-select-option>
          <a-select-option value="-1">未知</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="权限/角色"
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-select
          v-decorator="[
            'authority',
            {
              initialValue: authority,
            }
          ]"
          style="width: 120px"
          @change="handleChange"
        >
          <a-select-option value="100">超级管理员</a-select-option>
          <a-select-option value="200">项目管理员</a-select-option>
          <a-select-option value="300">医生</a-select-option>
          <a-select-option value="400">医生助理</a-select-option>
          <a-select-option value="500">患者</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
        <a-button type="primary" @click="handleSubmit">更新</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import request from "../../utils/request";

export default {
  data() {
    return {
      formLayout: "horizontal",
      form:this.$form.createForm(this),
      old: {},
      phone: "",
      password: "",
      name: "",
      sex: "",
      authority:""
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 }
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    }
  },
  methods: {
    getData(){
      request({
        url: "/user/"+this.$route.query.the_id,
        method: "get",
        params: {}
      }).then(response => {
        let data=response.data;
        if(data.success){
          // this.form.resetFields();
          this.old=data.data;
          this.phone=data.data.phone;
          this.password=data.data.password;
          this.name=data.data.name;
          this.sex=data.data.sex+"";
          this.authority=data.data.authority+"";
        }else{
          this.$message.error(data.msg);
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
    handleSubmit(){
      console.log(this.keys);
      this.form.validateFields((err, values) => {
        if (!err) {
          request({
            url: "/user/"+this.old.id+"/",
            method: "PUT",
            data: values
          }).then(response => {
            let data=response.data;
            if(data.success){
              this.form.resetFields();
              this.$message.success(data.msg);
              this.$router.push({path: '/user/manager/all'})
            }else{
              this.$message.error(data.msg);
            }
            console.log(response);
          });

        }
      });
    },
  }
};
</script>
